<template>
  <RepriseTableLayout
    class="
      overflow-hidden no-scroll
      sticky top-0 z3
    "
    :session-count="sessions.length"
  >
    <template #left-section>
      <v-row no-gutters class="flex-nowrap">
        <v-col
          v-for="header in leftTableHeaders"
          :key="header.value"
          :class="header.class"
          :align="header.align"
          class="d-flex align-center justify-space-between gap-1"
          :style="`min-width: ${ header.width }px; width: ${ header.width }px; max-width: ${ header.width }px;`"
        >
          <h4 class="mb-0 text-truncate">{{ header.text }}</h4>
          <section class="d-flex flex-column align-center justify-center gap-2">
            <v-btn
              icon
              x-small
              plain
              max-height="4"
              :ripple="false"
              :class="{ 'cursor-not-allowed': isLoading }"
              :color="sortBy.column === header.value && sortBy.direction === 'ASC' ? 'third' : 'grey darken-1'"
              @click="updateSort(header.value, 'ASC')"
            >
              <v-icon size="24">mdi-triangle-small-up</v-icon>
            </v-btn>
            <v-btn
              icon
              x-small
              plain
              max-height="4"
              :ripple="false"
              :class="{ 'cursor-not-allowed': isLoading }"
              :color="sortBy.column === header.value && sortBy.direction === 'DESC' ? 'third' : 'grey darken-1'"
              @click="updateSort(header.value, 'DESC')"
            >
              <v-icon size="24">mdi-triangle-small-down</v-icon>
            </v-btn>
          </section>
        </v-col>
      </v-row>
    </template>
    <template #right-section>
      <v-row no-gutters class="flex-nowrap">
        <v-col
          v-for="header in rightTableHeaders"
          :data-session-uuid="header.value"
          :key="header.value"
          :class="header.class"
          :align="header.align"
          class="d-flex align-center justify-space-between gap-1"
          :style="`min-width: ${ header.width }px; width: ${ header.width }px; max-width: ${ header.width }px;`"
        >
          <div
            class="
              d-flex align-center justify-space-between
              px-4
            "
            :style="`min-width: ${ header.width }px; width: ${ header.width }px; max-width: ${ header.width }px;`"
          >
            <h4 class="mb-0 text-truncate">{{ header.text }}</h4>
            <section class="d-flex flex-column align-center justify-center gap-2">
              <v-btn
                icon
                x-small
                plain
                max-height="4"
                :ripple="false"
                :class="{ 'cursor-not-allowed': isLoading }"
                :color="sortBy.column === header.value && sortBy.direction === 'ASC' ? 'third' : 'grey darken-1'"
                @click="updateSort(header.value, 'ASC')"
              >
                <v-icon size="24">mdi-triangle-small-up</v-icon>
              </v-btn>
              <v-btn
                icon
                x-small
                plain
                max-height="4"
                :ripple="false"
                :class="{ 'cursor-not-allowed': isLoading }"
                :color="sortBy.column === header.value && sortBy.direction === 'DESC' ? 'third' : 'grey darken-1'"
                @click="updateSort(header.value, 'DESC')"
              >
                <v-icon size="24">mdi-triangle-small-down</v-icon>
              </v-btn>
            </section>
          </div>
        </v-col>
      </v-row>
    </template>
  </RepriseTableLayout>
</template>


<script>
import RepriseTableLayout from './RepriseTableLayout.vue';

export default {
  name: 'RepriseTableHeaders',
  components: { RepriseTableLayout },
  props: {
    leftTableHeaders: { type: Array, required: true },
    rightTableHeaders: { type: Array, required: true },
    sessions: { type: Array, required: true },
    sortBy: { type: Object, required: true },
    isLoading: { type: Boolean, default: false }
  },
  emits: ['update-sort'],
  setup(_, { emit }) {
    const updateSort = (column, direction) => {
      emit('update-sort', { column, direction });
    };

    return { updateSort };
  }
};
</script>